import { render, staticRenderFns } from "./V2BrandPreviewCard.vue?vue&type=template&id=25c064ec&scoped=true&"
import script from "./V2BrandPreviewCard.vue?vue&type=script&lang=js&"
export * from "./V2BrandPreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./V2BrandPreviewCard.vue?vue&type=style&index=0&id=25c064ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c064ec",
  null
  
)

export default component.exports